export const EmailBodyTags = [
  {
    tag: "<product-section></product-section>",
    content: ``,
  },
  {
    tag: "<footer-section></footer-section>",
    content: ``,
  },
];
